<template>
    <div class="single-product__size-guide" data-index="1">
        <div class="single-product__size-guide-container">
            <a class="single-product__size-guide--btn" @click="show_guide__popup">Bracelet Size Guide</a><img alt="alert-info"  src="/single-product/alert-info-icon.webp">
        </div>
        <div class="size-guide__popup " id="size-guide__popup-1" :class="open ? 'active' : ''">
            <div class="size-guide__content" ref="contentRef">
                <h4 class="size-guide__heading">Bracelet Size Guide</h4>
                <div class="size-guide__tab-panel">
                    <span data-tab="size-chart" class="size-guide__tab size-guide__tab--size-chart" :class="{ 'active-tab': currentTab === 'size' }" @click="handleChainTab('size')">Size Chart</span>
                    <span data-tab="guide" class="size-guide__tab size-guide__tab--guide" :class="{ 'active-tab': currentTab === 'measurement' }" @click="handleChainTab('measurement')">Measurement Guide</span>
                </div>
                <div class="size-guide__tab-content size-guide__tab-content--size-chart" :class="{ 'active-tab': currentTab === 'size' }">
                    <div class="size-guide__size-chart">
                        <table>
                            <tbody>
                                <tr v-for="(row, rowIndex) in braceletSizes" :key="rowIndex">
                                    <td v-for="(cell, cellIndex) in row" :key="cellIndex">
                                    {{ cell }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="size-guide__size-chart--text">
                        <p>This bracelet size guide provides a general guideline, and personal fit preference may affect your final choice. For reference, an average Asian woman typically wears a size 16.0cm bracelet, while an average man might wear 17.5cm.</p>
                    </div>
                </div>
                <div class="size-guide__tab-content size-guide__tab-content--guide" :class="{ 'active-tab': currentTab === 'measurement' }">
                    <div class="ring-size__tab-content ring-size__tab-content--find-ring-size">
                        <h4>How Do I Find My Bracelet Size?</h4>
                        <div class="size-guide__method-title"><span></span><span> Using a measuring tape</span></div>
                        <img src="/single-product/bracelet-size-guide-1.webp" data-original_src="/single-product/bracelet-size-guide-1.webp" class="size-guide__image" alt="ring-size-guide-img">
                        <div class="size-guide__step">
                            <h4>Step 1</h4>
                            <span>With your palm open and facing up, wrap the measuring tape around your wrist, just above your wrist bone.</span>
                        </div>
                        <div class="size-guide__step">
                            <h4>Step 2</h4>
                            <span>Cross refer the measurement to the bracelet size chart and find the closest length.</span>
                        </div>

                    </div>
                </div>
                <div class="size-guide__footer">
                    <a @click="close_guide__popup" class="size-guide__close"><span>Continue Shopping</span></a>
                </div>
                <span class="size-guide__close-btn" @click="close_guide__popup">
                    <svg class="icon_close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6z"/></svg>
                </span>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_sizeguide.scss";
</style>

<script setup lang="ts">
const currentTab = ref('size');
    const braceletSizes = ref([
        ["Size", "Bracelet Length (CM)", "Wrist Circumference (CM)"],
        ["Small", "16.0 - 16.5", "15.0 - 15.5"],
        ["Medium", "17.0 - 17.5", "16.0 - 16.5"],
        ["Large", "18.0 - 18.5", "17.0 - 17.5"],
        ["Extra Large", "19.0 - 19.5", "18.0 - 18.5"]
    ]);
    const open = ref(false)

    const contentRef = ref<HTMLElement | null>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if (contentRef.value && !contentRef.value.contains(event.target as Node)) {
            close_guide__popup();
        }
    };
    const show_guide__popup = () =>{
        currentTab.value = 'size';
        open.value = true,
        document.body.style.overflowY = 'hidden';
        setTimeout(() => {
            document.addEventListener('click', handleClickOutside);
        }, 500);
    }
    const close_guide__popup = () =>{
        open.value = false,
        document.body.style.overflowY = 'scroll';
        document.removeEventListener('click', handleClickOutside);
    }
    const handleChainTab = (tab: string) => {
        currentTab.value = tab;
    }
</script>